import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

// Mirrors the b2b_reschedule_interview RPC payload. All rules live server-side:
// one reschedule per setup, new time in the future and <= original + 7 days,
// license valid_until extended (never shrunk; NULL = never expires, untouched).

export interface RescheduleResult {
  session_id: string;
  old_date: string;
  new_date: string;
  reschedule_deadline: string;
  /** New license expiry after extension; null when the license never expires. */
  license_valid_until: string | null;
}

export interface RescheduleInput {
  sessionId: string;
  /** ISO timestamp for the new interview time. */
  newDate: string;
}

export function useRescheduleSession() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (input: RescheduleInput): Promise<RescheduleResult> => {
      const { data, error } = await supabase.rpc(
        'b2b_reschedule_interview' as never,
        {
          p_session_id: input.sessionId,
          p_new_date: input.newDate,
        } as never
      );
      if (error) throw new Error(error.message);
      return data as unknown as RescheduleResult;
    },
    onSuccess: () => {
      // Prefix invalidation covers both the Interviews and Tests pages
      // (['neurax','interviews', companyId, filter]).
      qc.invalidateQueries({ queryKey: ['neurax', 'interviews'] });
    },
  });
}
